var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCommission = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.858 1.744h17.387c.6 0 1.087.487 1.087 1.087v1.723c0 .288-.114.565-.318.769l-6.97 6.97c-.204.204-.319.48-.319.768v6.852c0 .707-.664 1.226-1.35 1.054l-2.174-.543a1.09 1.09 0 0 1-.823-1.055v-6.308c0-.288-.114-.564-.318-.768l-6.97-6.97a1.09 1.09 0 0 1-.319-.769V2.831c0-.6.487-1.087 1.087-1.087"
})));
export default SvgCommission;